module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_doctor21-3958bdd6a56208d5203e4e5c75890aa6.png";